import React, { useCallback, useEffect, useState } from "react";
import styled from "styled-components";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import useInput from "./hooks/useInput";
import "./App.css";
import { useAppDispatch } from "./store";
import { Loadme } from "./reduxaction/user";
import {
  Route,
  Link,
  Routes,
  Navigate,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import axios, { AxiosError } from "axios";
import jwtDecode, { JwtPayload } from "jwt-decode";
import SignIn from "./Pages/SignFolder/SignIn";
import Regist from "./Pages/SignFolder/Regist";
import SignUp from "./Pages/SignFolder/SignUp";
import MainPage from "./Pages/MainFolder/MainPage";

import EnvirdataPage from "./Pages/MainFolder/EnvirdataPage";

import WholedataPage from "./Pages/MainFolder/WholedataPage";
import ExcelData from "./Pages/MainFolder/ExcelData";

import AdvicePage from "./Pages/MainFolder/AdvicePage/AdvicePage";
import AdviceWrite from "./Pages/MainFolder/AdvicePage/Advicewrite";
import AdviceDetail from "./Pages/MainFolder/AdvicePage/AdviceDetail";
import PostDiaryPage from "./Pages/MainFolder/PostDiary/PostDiaryPage/PostDiaryPage";
import DiaryDetail from "./Pages/MainFolder/PostDiary/DiaryDetail/DiaryDetail";
import PostSelectInsect from "./Pages/MainFolder/PostDiary/PostSelectInsect";
import DiaryPage from "./Pages/MainFolder/PostDiary/DiaryPage";
import Setting from "./Pages/MainFolder/Setting/Setting";
import AddressList from "./Pages/MainFolder/Setting/AddressList";
import ChangeName from "./Pages/MainFolder/Setting/ChangeName";
import ChangePassword from "./Pages/MainFolder/Setting/ChangePassword";

import NotiSetting from "./Pages/MainFolder/Setting/NotiSetting";

import NoticeList from "./Pages/MainFolder/Setting/NoticeList";
import ProfileAdjust from "./Pages/MainFolder/Setting/ProfileAdjust";
import { useSelector } from "react-redux";
import { RootState } from "../src/reducer/index";
import userSlice from "./reducer/user";

import SelectSetting from "./Pages/MainFolder/DefaultSetting/SelectSetting";
import Critical from "./Pages/MainFolder/DefaultSetting/Critical";
import Feedmanagement from "./Pages/MainFolder/DefaultSetting/Feedmanagement";
import FeedAdd from "./Pages/MainFolder/DefaultSetting/FeedAdd";
import Boxmanagement from "./Pages/MainFolder/DefaultSetting/Boxmanagement/Boxmanagement";
import BoxAdd from "./Pages/MainFolder/DefaultSetting/Boxmanagement/BoxAdd";
import BoxAddAll from "./Pages/MainFolder/DefaultSetting/Boxmanagement/BoxAddAll";

import MonitoringPage from "./Pages/MainFolder/MonitoringPage";

export const API_BASE_URL = process.env.REACT_APP_API_ROOT;

export interface JwtPayloads {
  preferred_username: string;
}

function App() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    // 엑세스 토큰 리프레시 토큰 가져오는 로직
    const Loadmefunc = () => {
      let accessToken = localStorage.getItem("accessToken");
      let refreshToken = localStorage.getItem("refreshToken");
      if (accessToken) {
        let userId = accessToken;

        let data = {
          accessToken: accessToken,
          refreshToken: refreshToken,
          userId: userId,
        };
        dispatch(Loadme(data));
      }
    };

    Loadmefunc();
  }, [dispatch]);

  axios.interceptors.request.use(
    async (config: any) => {
      const AccessToken = await localStorage.getItem("accessToken");
      // console.log("config:", config);
      return {
        ...config,
        headers: {
          Authorization: `Bearer ${AccessToken}`,
          ...config.headers,
        },
      };
    },
    async (error) => {
      console.log("error:", error);
      return Promise.reject(error);
    }
  );

  const logout = () => {
    localStorage.clear();
    dispatch(userSlice.actions.reMoveme());
    navigate("/SignIn");
  };
  useEffect(() => {
    axios.interceptors.response.use(
      (response) => {
        return response;
      },
      async (error) => {
        console.log("error!!!:", error);
        const {
          config,

          response: { status },
        } = error;
        if (status === 402) {
          if (error.response.data.code === "expired") {
            const originalRequest = config;
            // 419로 요청 실패했던 요청 새로운 토큰으로 재요청
            return axios(originalRequest);
          }
        } else if (status === 401) {
          if (error.response.data.message === "Unauthorized") {
            console.log("토큰만료!!!!!!!!!");
            confirmAlert({
              title: "알림!",
              message: "세션이 만료되었습니다. 다시 로그인 해주세요.",
              buttons: [
                {
                  label: "Yes",
                  onClick: () => logout(),
                },
                // {
                //   label: "No",
                //   onClick: () => alert("Click No"),
                // },
              ],
            });
            // localStorage.clear();
            // dispatch(userSlice.actions.reMoveme());
            // navigate("/SignIn");
          }
        }
        return Promise.reject(error);
      }
    );
  }, []);

  useEffect(() => {
    let accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
    } else {
      navigate("/SignIn");
    }
  }, []);

  const [searchParams, setSearchParams] = useSearchParams();

  let fcmtoken = searchParams.get("fcmtoken");

  useEffect(() => {
    const hello = async () => {
      try {
        let accessToken = await localStorage.getItem("accessToken");

        if (accessToken && fcmtoken) {
          const response = await axios.put(`ifactory/api/member/updateToken`, {
            token: fcmtoken,
          });
        }
      } catch (error) {
        // alert(error);
        console.error(error);
        console.log("error:", error);
      }
    };

    hello();
  }, []);

  return (
    <Routes>
      <Route path="/" element={<SignIn />} />
      <Route path="/SignIn" element={<SignIn />} />
      <Route path="/SignUp" element={<SignUp />} />
      <Route path="/MainPage" element={<MainPage />} />

      <Route path="/Setting" element={<Setting />} />
      <Route path="/AddressList" element={<AddressList />} />
      <Route path="/ProfileAdjust" element={<ProfileAdjust />} />
      <Route path="/ChangeName" element={<ChangeName />} />
      <Route path="/ChangePassword" element={<ChangePassword />} />
      <Route path="/NotiSetting" element={<NotiSetting />} />
      <Route path="/NoticeList" element={<NoticeList />} />

      <Route path="/DiaryPage" element={<DiaryPage />} />
      <Route path="/EnvirdataPage" element={<EnvirdataPage />} />
      <Route path="/AdvicePage" element={<AdvicePage />} />
      <Route path="/Advicewrite" element={<AdviceWrite />} />
      <Route path="/AdviceDetail" element={<AdviceDetail />} />
      <Route path="/PostSelectInsect" element={<PostSelectInsect />} />
      <Route path="/PostDiaryPage" element={<PostDiaryPage />} />
      <Route path="/DiaryDetail" element={<DiaryDetail />} />
      <Route path="/WholedataPage" element={<WholedataPage />} />
      <Route path="/ExcelData" element={<ExcelData />} />

      <Route path="/SelectSetting" element={<SelectSetting />} />
      <Route path="/Critical" element={<Critical />} />
      <Route path="/Feedmanagement" element={<Feedmanagement />} />
      <Route path="/FeedAdd" element={<FeedAdd />} />
      <Route path="/Boxmanagement" element={<Boxmanagement />} />
      <Route path="/BoxAdd" element={<BoxAdd />} />
      <Route path="/BoxAddAll" element={<BoxAddAll />} />

      <Route path="/MonitoringPage" element={<MonitoringPage />} />
    </Routes>
  );
}
export default App;
